import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/_components/CookieNotice.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/ai-feature/career-planing.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/ai-feature/mock-interview.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/ai-feature/resume-analysis.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/ai-feature/resume-optimize.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/bg-index.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/logo.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/svg/star-3.svg");
;
import(/* webpackMode: "eager" */ "/app/components/infinite-move-img/InfiniteMoveImg.module.css");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/bg-connector-2.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/bg-connector.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/bg-resume-template.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/customized-color.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/customized-format.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/customized-module.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/customized-template.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/feature-all.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/feature-ats-optimization.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/feature-visual-editor.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/logo-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/quote-left.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/quote-right.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/resume-example.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/resume-share.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/resume-translate.png");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/text-bg.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/user-saying-mask-bottom.svg");
;
import(/* webpackMode: "eager" */ "/app/components/landing-page/assets/user-saying-mask-top.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/landing-page/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/LoginButtonGroup/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/region-tips/RegionTips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/UtmTracking/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@next+third-parties@14.2.26_next@14.2.25_react@18.3.1/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@next+third-parties@14.2.26_next@14.2.25_react@18.3.1/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@next+third-parties@14.2.26_next@14.2.25_react@18.3.1/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.25_@babel+core@7.24.5_react-dom@18.3.1_react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"app/_layout/RootLayout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
